import * as s from "react";
function o(_ref) {
  let {
    children: e,
    render: t = "idle",
    unmount: i = "never",
    ...n
  } = _ref;
  let [u, c] = s.useState(!n.hidden || t === "always");
  return s.useEffect(() => {
    !n.hidden || t === "always" ? c(!0) : t === "idle" ? ("requestIdleCallback" in window ? requestIdleCallback : setTimeout)(() => c(!0)) : i === "always" ? c(!1) : i === "idle" && ("requestIdleCallback" in window ? requestIdleCallback : setTimeout)(() => c(!1));
  }, [n.hidden, t, i]), s.createElement("div", {
    ...n
  }, u ? e : null);
}
import * as l from "react";
function d(e) {
  let t = l.useRef();
  return l.useEffect(() => {
    t.current = e;
  }), t.current;
}
function f(e, t) {
  let i = l.useState(),
    [n, u] = i,
    c = l.useMemo(() => n ? e.indexOf(n) : -1, [n, e]),
    r = d(c);
  return l.useEffect(() => {
    if (e.length === 0) {
      u(void 0);
      return;
    }
    if (!(n === null || n && e.includes(n))) {
      if (typeof r == "number" && r >= 0 && (e[r] || e[r - 1])) {
        u(e[r] || e[r - 1]);
        return;
      }
      t !== null && u(t && e.includes(t) ? t : e[0]);
    }
  }, [t, r, n, u, e]), i;
}
export { o as TabPanel, f as useTabs };